import {connect, useDispatch} from 'react-redux';
import {Dispatch} from 'redux';
import * as _ from 'lodash';
import {DATA_PROVIDER_CALL} from '../actions/types';
import {DataProviderErrorResponseShape, DataProviderResponseDataShape, DispatchProps} from './tsTypes';

export const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
    dispatch: dispatch,
    dataProvider: (type,
        resource,
        params,
        meta = {},
    ): Promise<DataProviderResponseDataShape> =>
        new Promise((resolve, reject) => {
            const onSuccess = _.get(meta, 'onSuccess', {});
            const onFailure = _.get(meta, 'onFailure', {});

            const action = {
                type: DATA_PROVIDER_CALL,
                payload: params,
                meta: {
                    ...meta,
                    resource,
                    fetch: type,
                    onSuccess: {
                        ...onSuccess,
                        callback: (response: DataProviderResponseDataShape): void => {
                            if (onSuccess.callback) {
                                onSuccess.callback(response);
                            }

                            resolve(response);
                        },
                    },
                    onFailure: {
                        ...onFailure,
                        callback: (error: DataProviderErrorResponseShape): void => {
                            if (onFailure.callback) {
                                onFailure.callback(error);
                            }

                            reject(error);
                        },
                    },
                },
            };
            dispatch(action);
        }),
});

export const withDataProvider = <T>(Component: any): object =>
    connect<{}, DispatchProps, T>(null, mapDispatchToProps)
    (Component as any);

export const useDataProvider = (): DispatchProps => {
    const dispatch = useDispatch();
    return mapDispatchToProps(dispatch);
};